import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import Select from "react-select";
import { all_routes } from "../../Router/all_routes";
import { DatePicker } from "antd";
import Addunits from "../../core/modals/inventory/addunits";
import AddCategory from "../../core/modals/inventory/addcategory";
import AddBrand from "../../core/modals/addbrand";
import {
  ArrowLeft,
  Calendar,
  Info,
  LifeBuoy,
  List,
  Plus,
  PlusCircle,
} from "feather-icons-react/build/IconComponents";
// import ImageWithBasePath from "../../core/img/imagewithbasebath";
// import CounterThree from "../../core/common/counter/counterThree";
import RefreshIcon from "../../core/common/tooltip-content/refresh";
import CollapesIcon from "../../core/common/tooltip-content/collapes";
import AddVariant from "../../core/modals/inventory/addvariant";
import AddVarientNew from "../../core/modals/inventory/addVarientNew";
import CommonTagsInput from "../../core/common/Taginput";
import TextEditor from "./texteditor";
import {
  addProduct,
  checkSkuExists,
  bulkUploadProducts,
  uploadCatalogImage,
} from "../../api/productApi";
import { getAllSubCategories } from "../../api/subCategoryApi";
import { getAllStores } from "../../api/storeApi";
import { getAllWarehouses } from "../../api/warehouseApi";
import { getAllBrandsList } from "../../api/brandApi";
import { getAllUnitsList } from "../../api/unitApi";
import { getAllVariantAttributes } from "../../api/productVariantApi";
import { getAllTaxes } from "../../api/taxApi";
import { api } from "../../api/client";
import * as XLSX from "xlsx";

import axios from "axios";
import { toast } from "react-toastify";

const normalizeKey = (s) => {
  if (!s) return "";
  let v = String(s).trim();
  v = v.replace(/^\/+/, ""); // remove leading slash
  v = v.replace(/^catalog\//i, "catalog/"); // normalize
  if (!/^catalog\//i.test(v)) {
    v = `catalog/${v.split("/").pop()}`;
  }
  return v;
};


const AddProduct = () => {
  const route = all_routes;
  const [tags, setTags] = useState(["Red", "Black"]);
  const [product, setProduct] = useState(false);
  const [product2, setProduct2] = useState(true);

  const [productNameEN, setProductNameEN] = useState("");
  const [productNameAR, setProductNameAR] = useState("");

  const [slugEN, setSlugEN] = useState("");
  const [slugAR, setSlugAR] = useState("");

  const [descriptionEN, setDescriptionEN] = useState("");
  const [descriptionAR, setDescriptionAR] = useState("");

  const [manufacturerEN, setManufacturerEN] = useState("");
  const [manufacturerAR, setManufacturerAR] = useState("");

  const [sku, setSku] = useState("");
  const [itemCode, setItemCode] = useState("");

  const [price, setPrice] = useState("");
  const [quantity, setQuantity] = useState("");

  const [discountValue, setDiscountValue] = useState("");
  const [quantityAlert, setQuantityAlert] = useState("");

  const [storeValue, setStoreValue] = useState(null);
  const [warehouseValue, setWarehouseValue] = useState(null);
  const [sellingTypeValue, setSellingTypeValue] = useState(null);
  const [categoryValue, setCategoryValue] = useState(null);
  const [category, setCategory] = useState([]);
  const [subCategoryValue, setSubCategoryValue] = useState(null);
  const [brandValue, setBrandValue] = useState(null);
  const [unitValue, setUnitValue] = useState(null);
  const [unitList, setUnitList] = useState([]);
  const [barcodeSymbologyValue, setBarcodeSymbologyValue] = useState(null);
  const [warrantyValue, setWarrantyValue] = useState(null);
  const [taxType, setTaxType] = useState(null);
  const [discountType, setDiscountType] = useState(null);

  const [productType, setProductType] = useState("single"); // 'single' or 'variable'
  const [manufacturedDate, setManufacturedDate] = useState(null);
  const [expiryDate, setExpiryDate] = useState(null);
  // const [image, setImage] = useState(null);
  const [allSubCategories, setAllSubCategories] = useState([]);
  const [storeList, setStoreList] = useState([]);
  const [warehouseList, setWarehouseList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [warrantyList, setWarrantyList] = useState([]);
  const [taxTypeOptions, setTaxTypeOptions] = useState([]);
  const [loadingTaxTypes, setLoadingTaxTypes] = useState(false);

  const [showVariableProduct] = useState(true);
  const [subCategoryOptions, setSubCategoryOptions] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [variantAttributes, setVariantAttributes] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState("");
  const [variantValues, setVariantValues] = useState([]);
  // const [selectedImage, setSelectedImage] = useState(null);
  // const [variantPrice, setVariantPrice] = useState([]);

  // inside component state belong to single/bulk mode
  const [mode, setMode] = useState("single"); // "single" | "bulk"
  const [bulkFile, setBulkFile] = useState(null);
  const [bulkRows, setBulkRows] = useState([]); // parsed raw rows from file
  const [bulkItems, setBulkItems] = useState([]); // mapped for API
  const [bulkErrors, setBulkErrors] = useState([]); // per row errors
  const [uploading, setUploading] = useState(false);

  const [imagePreview, setImagePreview] = useState(null); // for UI
  const [imageKey, setImageKey] = useState(""); // the "/catalog/xxx.jpg" you'll send

  const [isSubmitting, setIsSubmitting] = useState(false);
  const idemKeyRef = useRef(null);

  const navigate = useNavigate();

  // Fetch category
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await api.get(
          `${API_BASE_URL}api/categories/category-list`,
        );

        console.log("Raw category API response:", res.data);

        // 🟢 Filter only active categories (case-insensitive check just in case)
        const activeCategories = res.data.filter(
          (cat) => cat.status?.toLowerCase() === "active",
        );

        if (activeCategories.length === 0) {
          console.warn("No active categories found.");
        }

        const formatted = activeCategories.map((cat) => ({
          value: cat.id,
          label: cat.name || "Unnamed Category",
        }));

        console.log("Formatted active category options:", formatted);

        setCategory(formatted);
        console.log("Category state updated:", formatted);
        console.log("All categories:", res.data);
      } catch (error) {
        console.error("Failed to load categories:", error);
      }
    };

    fetchCategories();
  }, [API_BASE_URL]);

  // Fetch Sub Category
  useEffect(() => {
    const fetchSubCategories = async () => {
      try {
        const data = await getAllSubCategories();

        // 🟢 Filter only active subcategories
        const activeSubcategories = data.filter(
          (sub) => sub.status?.toLowerCase() === "active",
        );

        const formatted = activeSubcategories.map((sub) => ({
          value: sub.id,
          label: sub.name || "Unnamed Subcategory",
        }));

        console.log("Formatted active subcategories:", formatted);
        setAllSubCategories(formatted);
      } catch (error) {
        console.error("Error loading subcategories:", error);
      }
    };

    fetchSubCategories();
  }, []);

  // Fetch Sub Category Filter
  useEffect(() => {
    const fetchSubCategories = async () => {
      try {
        const data = await getAllSubCategories();

        const activeSubcategories = data.filter(
          (sub) => sub.status?.toLowerCase() === "active",
        );

        // ✅ Keep full data including parentCategory
        setAllSubCategories(activeSubcategories);
      } catch (error) {
        console.error("Error loading subcategories:", error);
      }
    };

    fetchSubCategories();
  }, []);

  // Selected Category Value
  useEffect(() => {
    if (!categoryValue) return;

    const filtered = allSubCategories
      .filter((sub) => sub.parentCategory === categoryValue.value)
      .map((sub) => ({
        value: sub.id || sub._id,

        label: sub.category || "Unnamed Subcategory",
      }));

    console.log("Filtered Subcategories:", filtered);

    setSubCategoryOptions(filtered);
  }, [categoryValue, allSubCategories]);

  // Fetch the Store
  useEffect(() => {
    const fetchStores = async () => {
      try {
        const data = await getAllStores(); // API call from storeApi.js

        if (Array.isArray(data) && data.length > 0) {
          const storeOptions = data.map((store) => ({
            value: store.id || store._id, // fallback for different id field names
            label: store.CustomerName || store.storeName?.en || "Unnamed Store",
          }));
          setStoreList(storeOptions);
        } else {
          console.warn("No stores found or data format issue");
          setStoreList([]); // optional fallback to empty
        }
      } catch (error) {
        console.error("❌ Failed to load stores in useEffect:", error);
        setStoreList([]); // fallback in error
      }
    };

    fetchStores();
  }, []);

  // Fetch the wareshouse
  useEffect(() => {
    const fetchWarehouses = async () => {
      try {
        const warehouses = await getAllWarehouses();

        const formatted = warehouses.map((w) => ({
          value: w.id || w._id,
          label: w.warehouseName?.en || w.warehouse || "Unnamed Warehouse",
        }));

        setWarehouseList(formatted);
      } catch (err) {
        console.error("Failed to fetch active warehouses:", err);
      }
    };

    fetchWarehouses();
  }, []);

  // Fetch brands list
  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const brands = await getAllBrandsList();

        const formatted = brands.map((brand) => ({
          value: brand.id || brand._id,
          label: brand.brandName?.en || brand.brand || "Unnamed Brand",
        }));

        setBrandList(formatted);
      } catch (err) {
        console.error("Failed to load brands:", err);
        setBrandList([]); // fallback
      }
    };

    fetchBrands();
  }, []);

  // Fetch unit
  useEffect(() => {
    const fetchUnits = async () => {
      try {
        const units = await getAllUnitsList();
        console.log("✅ Raw units from API:", units);

        const formatted = units.map((unit) => ({
          value: unit._id || unit.id,
          label: unit.unitName?.en || "Unnamed Unit",
        }));

        console.log("✅ Formatted unit list:", formatted);
        setUnitList(formatted);
      } catch (err) {
        console.error("❌ Failed to fetch units:", err);
        setUnitList([]);
      }
    };

    fetchUnits();
  }, []);

  //generate SKU Randomly
  const generateRandomSku = () => {
    const prefix = "SKU";
    const randomNum = Math.floor(100000 + Math.random() * 900000); // 6-digit number
    return `${prefix}-${randomNum}`;
  };

  // generate Item Rndomly
  const generateRandomItemCode = () => {
    const prefix = "ITM";
    const randomNum = Math.floor(100000 + Math.random() * 900000);
    return `${prefix}-${randomNum}`;
  };

  // Fetch warranty list
  useEffect(() => {
    const fetchWarranties = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}api/warranties`, {
          headers: {
            "Accept-Language": localStorage.getItem("lang") || "en",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        const data = response.data;

        // Optional: Filter active warranties
        const activeWarranties = data.filter(
          (warranty) => warranty.status?.toLowerCase() === "active",
        );

        const formatted = activeWarranties.map((warranty) => ({
          value: warranty._id || warranty.id,
          label:
            warranty.warrantyName?.en || warranty.name || "Unnamed Warranty",
        }));

        setWarrantyList(formatted);
      } catch (error) {
        console.error("❌ Failed to fetch warranties:", error);
        setWarrantyList([]);
      }
    };

    fetchWarranties();
  }, [API_BASE_URL]);

  // Fetch tax types
  useEffect(() => {
    const fetchTaxTypes = async () => {
      try {
        setLoadingTaxTypes(true);
        const res = await getAllTaxes({
          page: 1,
          limit: 100,
          sortBy: "createdAt",
          sortOrder: "desc",
        });

        const taxes = Array.isArray(res?.data) ? res.data : [];
        const activeTaxes = taxes.filter((tax) => {
          const status = tax?.status;
          if (typeof status === "boolean") return status;
          if (typeof status === "string") {
            const normalized = status.toLowerCase();
            return normalized === "active" || normalized === "true";
          }
          return true;
        });

        const seen = new Set();
        const options = activeTaxes
          .map((tax) => {
            const typeLabel = String(
              tax?.taxType || tax?.taxName?.en || tax?.taxName?.ar || "",
            ).trim();
            if (!typeLabel) return null;

            const rate = Number(tax?.taxRate);
            const rateLabel = Number.isFinite(rate)
              ? `${parseFloat(rate.toFixed(2))}%`
              : "0%";

            return {
              value: typeLabel,
              label: `${typeLabel} (${rateLabel})`,
            };
          })
          .filter(Boolean)
          .filter((opt) => {
            if (seen.has(opt.value)) return false;
            seen.add(opt.value);
            return true;
          });

        setTaxTypeOptions(options);

        setTaxType((prev) => {
          if (!prev) return prev;
          return options.some((opt) => opt.value === prev.value) ? prev : null;
        });
      } catch (error) {
        console.error("Failed to fetch tax types:", error);
        setTaxTypeOptions([]);
      } finally {
        setLoadingTaxTypes(false);
      }
    };

    fetchTaxTypes();
  }, []);

  // Fetch Variant
  useEffect(() => {
    const fetchVariantAttributes = async () => {
      try {
        const data = await getAllVariantAttributes();
        setVariantAttributes(data || []);
      } catch (error) {
        console.error("Error fetching variant attributes:", error);
      }
    };

    fetchVariantAttributes();
  }, []);

  useEffect(() => {
    if (selectedVariant && selectedVariant.values) {
      const values = selectedVariant.values;
      const tagsList = values.map((v) => v.en);

      setVariantValues(values);
      setTags(tagsList);

      // Add this logic to generate basic placeholder entries:
      const variants = tagsList.map((tag) => ({
        attribute: {
          en: selectedVariant.name?.en || "N/A",
          ar: selectedVariant.name?.ar || selectedVariant.name?.en || "N/A", // ✅ fallback to en
        },
        value: {
          en: tag,
          ar: tag, // ✅ at least use same as `en` or ask user to input
        },
        sku: generateRandomSku(),
        quantity: 0,
        price: 0,
        barcodeSymbology: "",
        itemCode: generateRandomItemCode(),
        discountType: "",
        discountValue: 0,
        taxType: "",
        tax: "",
        quantityAlert: 0,
        image: "",
      }));

      setVariantList(variants);
    } else {
      setVariantValues([]);
      setTags([]);
      setVariantList([]);
    }
  }, [selectedVariant]);

  // const [variantData, setVariantData] = useState([]);

  const [variantList, setVariantList] = useState([]);
  const [modalData, setModalData] = useState({});
  const [editingIndex, setEditingIndex] = useState(null);

  useEffect(() => {
    const modalElement = document.getElementById("add-variation");
    if (modalElement) {
      // Initialize modal if not already initialized
      if (!window.bootstrap.Modal.getInstance(modalElement)) {
        new window.bootstrap.Modal(modalElement);
      }
    }
  }, []);

  const handleVariantSubmit = (data) => {
    setVariantList((prev) => {
      const updated = [...prev];
      if (editingIndex !== null) {
        updated[editingIndex] = data;
      } else {
        updated.push(data);
      }
      return updated;
    });

    setModalData({});
    setEditingIndex(null);

    // ✅ Blur focused element to avoid ARIA conflict
    if (
      document.activeElement &&
      typeof document.activeElement.blur === "function"
    ) {
      document.activeElement.blur();
    }

    const modalElement = document.getElementById("add-variation");

    // ✅ Recreate modal instance from scratch every time
    // Destroy previous instance if it exists
    const oldInstance = window.bootstrap.Modal.getInstance(modalElement);
    if (oldInstance) {
      oldInstance.dispose(); // fully destroy previous instance
    }

    // Recreate and hide
    const newInstance = new window.bootstrap.Modal(modalElement);
    newInstance.hide();

    // ✅ Clean up stuck backdrop
    setTimeout(() => {
      document.body.classList.remove("modal-open");
      const backdrops = document.querySelectorAll(".modal-backdrop");
      backdrops.forEach((el) => el.remove());
    }, 300);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return; // 🚫 hard guard against double-clicks
    setIsSubmitting(true);
    idemKeyRef.current = crypto?.randomUUID?.() || String(Date.now());

    try {
      // SKU validation
      if (!sku) {
        toast.error(
          `❌ ${window.translate(
            "SKU is required. Please generate or enter one.",
          )}`,
        );
        return;
      }
      const exists = await checkSkuExists(sku);
      if (exists) {
        toast.error(
          `❌ ${window.translate(
            "SKU already exists. Please use a different one.",
          )}`,
        );
        return;
      }

      const product = {
        store: storeValue?.value || "",
        warehouse: warehouseValue?.value || "",
        productName: { en: productNameEN, ar: productNameAR },
        slug: { en: slugEN, ar: slugAR },
        sku,
        itemCode,
        description: { en: descriptionEN, ar: descriptionAR },
        sellingType: sellingTypeValue?.value || "",
        category: categoryValue?.value || "",
        subcategory: subCategoryValue?.value || "",
        brand: brandValue?.value || "",
        unit: unitValue?.value || "",
        barcodeSymbology: barcodeSymbologyValue?.value || "",
        warranty: warrantyValue?.value || "",
        manufacturer: { en: manufacturerEN, ar: manufacturerAR },
        manufacturedDate,
        expiryDate,
        hasWarranty: !!warrantyValue,
        hasExpiry: !!expiryDate,
        productType,
        images: normalizeKey(imageKey || ""),
        imageFileName: "",
      };

      const pricing = {
        productType,
        quantity: parseInt(quantity) || 0,
        price: parseFloat(price) || 0,
        taxType: taxType?.value || "",
        discountType: discountType?.value || "",
        discountValue: parseFloat(discountValue) || 0,
        quantityAlert: parseInt(quantityAlert) || 0,
      };

      const payload = {
        product,
        pricing,
        variantAttributes:
          productType === "variable" && selectedVariant?.name?._id
            ? [selectedVariant.name._id]
            : [],
        variants: productType === "variable" ? variantList : [],
      };

      // ⬇️ pass an Idempotency-Key if your API can use it to dedupe
      const result = await addProduct(payload, {
        headers: { "Idempotency-Key": idemKeyRef.current },
      });

      if (result.success) {
        alert(window.translate("✅ Product added successfully!"));
        navigate("/product-list");
      } else {
        alert(
          `❌ ${window.translate("Failed to add product")}: ${result.error}`,
        );
      }
    } catch (err) {
      console.error(err);
      toast.error(
        window.translate("Something went wrong while adding the product."),
      );
    } finally {
      setIsSubmitting(false);
      idemKeyRef.current = null;
    }
  };

  const handleImageChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = async () => {
      try {
        const dataUrl = reader.result; // base64 data URL
        setImagePreview(dataUrl);

        // build a clean deterministic name with original extension
        const ext = (file.type && file.type.split("/")[1]) || "jpg";
        const stamp = new Date()
          .toISOString()
          .replace(/[-:.TZ]/g, "")
          .slice(0, 14);
        const desiredName = `IMG_${stamp}.${ext}`;

        // IMPORTANT: call the new backend route that returns { key: "catelog/..." }
        const { key } = await uploadCatalogImage(dataUrl, desiredName); // your api should POST to /catelog-image
        setImageKey(normalizeKey(key)); // ensure stored as "catelog/..."
      } catch (err) {
        console.error(err);
        toast.error(window.translate("Image upload failed"));
        setImagePreview(null);
        setImageKey("");
      }
    };
    reader.readAsDataURL(file);
  };

  const handleRemoveImage = () => {
    setImagePreview(null);
    setImageKey("");
  };

  // Bulk upload handler
  // helper: create a downloadable template
  const handleDownloadTemplate = () => {
    // Use name-based columns (Id columns are optional)
    const headers = [
      "storeName",
      "storeId (optional)",
      "warehouseName",
      "warehouseId (optional)",
      "unitName",
      "unitId (optional)",
      "productType", // single | variable
      "productName_en",
      "productName_ar",
      "slug_en",
      "slug_ar",
      "sku",
      "itemCode",
      "sellingType", // transactionalSelling | solutionSelling | ...
      "categoryName",
      "categoryId (optional)",
      "subcategoryName",
      "subcategoryId (optional)",
      "brandName",
      "description_en",
      "description_ar",
      "brandId (optional)",
      "barcodeSymbology", // code34 | code35 | code36
      "warrantyName",
      "warrantyId (optional)",
      "manufacturer_en",
      "manufacturer_ar",
      "manufacturedDate", // 2025-08-11
      "expiryDate", // 2026-01-10
      // "imagesBase64",
      "price",
      "quantity",
      "taxType", // exclusive | salesTax
      "discountType", // percentage | cash | ''
      "discountValue",
      "quantityAlert",
      "variantAttributeName",
      "variantAttributeId (optional)",
      "variantValues_en", // e.g. "Red;Green;Blue"

      // NEW (all optional) — position-aligned with variantValues_en
      "variant_prices",
      "variant_quantities",
      "variant_taxTypes",
      "variant_discountTypes",
      "variant_discountValues",
      "variant_quantityAlerts",
      "variant_itemCodes",
      "variant_barcodeSymbologies",
    ];

    const wsTemplate = XLSX.utils.aoa_to_sheet([headers]);

    // Build "Reference" data (Name + ID) from your already fetched lists
    const refRows = [];

    refRows.push(["== STORES =="]);
    refRows.push(["Name", "ID"]);
    (storeList || []).forEach((s) => refRows.push([s.label, s.value]));
    refRows.push([""]);

    refRows.push(["== WAREHOUSES =="]);
    refRows.push(["Name", "ID"]);
    (warehouseList || []).forEach((w) => refRows.push([w.label, w.value]));
    refRows.push([""]);

    refRows.push(["== UNITS =="]);
    refRows.push(["Name", "ID"]);
    (unitList || []).forEach((u) => refRows.push([u.label, u.value]));
    refRows.push([""]);

    refRows.push(["== BRANDS =="]);
    refRows.push(["Name", "ID"]);
    (brandList || []).forEach((b) => refRows.push([b.label, b.value]));
    refRows.push([""]);

    refRows.push(["== CATEGORIES =="]);
    refRows.push(["Name", "ID"]);
    (category || []).forEach((c) => refRows.push([c.label, c.value]));
    refRows.push([""]);

    refRows.push(["== SUBCATEGORIES =="]);
    refRows.push(["Name", "ID", "ParentCategoryId"]);
    (allSubCategories || []).forEach((sc) => {
      const name = sc.category || sc.name || "Unnamed Subcategory";
      const id = sc._id || sc.id || sc.value;
      refRows.push([name, id, sc.parentCategory || ""]);
    });
    refRows.push([""]);

    refRows.push(["== WARRANTIES =="]);
    refRows.push(["Name", "ID"]);
    (warrantyList || []).forEach((w) => refRows.push([w.label, w.value]));
    refRows.push([""]);

    refRows.push(["== VARIANT ATTRIBUTES =="]);
    refRows.push(["Name", "ID"]);
    (variantAttributes || []).forEach((va) => {
      refRows.push([va?.name?.en || "", va?.name?._id || ""]);
    });
    refRows.push([""]);

    // helpful constants
    refRows.push(["== CONSTANTS =="]);
    refRows.push(["productType", "single | variable"]);
    refRows.push(["sellingType", "transactionalSelling | solutionSelling"]);
    refRows.push(["barcodeSymbology", "code34 | code35 | code36"]);
    refRows.push(["taxType", "exclusive | salesTax"]);
    refRows.push(["discountType", "percentage | cash | (empty)"]);
    refRows.push([""]);

    // short guide for per-variant columns
    refRows.push(["== PER-VARIANT COLUMNS (optional) =="]);
    refRows.push([
      "These columns align by position with variantValues_en. Use semicolons to separate values.",
    ]);
    refRows.push(["Example"]);
    refRows.push(["variantValues_en", "Red;Green;Blue"]);
    refRows.push(["variant_prices", "100;110;120"]);
    refRows.push(["variant_quantities", "5;10;8"]);
    refRows.push(["(others)...", ""]);
    refRows.push([
      "If a cell is missing/blank at a position, that variant falls back to the row-level defaults (price, quantity, etc.).",
    ]);

    const wsRef = XLSX.utils.aoa_to_sheet(refRows);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, wsTemplate, "Template");
    XLSX.utils.book_append_sheet(wb, wsRef, "Reference");

    XLSX.writeFile(wb, "bulk_products_template.xlsx");
  };

  const normalize = (s) => (s || "").toString().trim().toLowerCase();

  // Build maps from your option arrays: [{label, value}]
  const makeNameToId = (arr) => {
    const m = new Map();
    (arr || []).forEach((o) => m.set(normalize(o.label), o.value));
    return m;
  };

  // for subcategories we also want id->parent map (optional)
  const makeSubcatNameToId = (arr) => {
    const m = new Map();
    (arr || []).forEach((sc) => {
      const name = sc.category || sc.name || sc.label;
      const id = sc._id || sc.id || sc.value;
      m.set(normalize(name), id);
    });
    return m;
  };

  // parse workbook → rows
  // parse workbook → rows (and upload images to S3)
  const parseFile = async (file) => {
    const data = await file.arrayBuffer();
    const wb = XLSX.read(data, { type: "array" });
    const ws = wb.Sheets[wb.SheetNames[0]];
    const json = XLSX.utils.sheet_to_json(ws, { defval: "" }); // array of objects by header

    // Just store and map rows — do NOT upload any images
    setBulkRows(json);
    mapRowsToItems(json);
  };

  // map raw rows to backend payload
  const mapRowsToItems = (rows) => {
    // Build maps once
    const storeByName = makeNameToId(storeList);
    const warehouseByName = makeNameToId(warehouseList);
    const unitByName = makeNameToId(unitList);
    const brandByName = makeNameToId(brandList);
    const categoryByName = makeNameToId(category);
    const subcatByName = makeSubcatNameToId(allSubCategories);
    const warrantyByName = makeNameToId(warrantyList);

    // Variant attribute: simple name->id map from variantAttributes
    const vaByName = new Map(
      (variantAttributes || []).map((va) => [
        normalize(va?.name?.en),
        va?.name?._id,
      ]),
    );

    const errs = [];
    const items = rows.map((r, idx) => {
      const err = [];
      const must = (v, name) => (!v ? err.push(`${name} is required`) : null);

      // helper to resolve IDs by explicit id OR by name lookup
      const resolve = (id, name, map) => id || map.get(normalize(name)) || "";

      const storeId = resolve(
        r["storeId (optional)"] || r.storeId,
        r.storeName,
        storeByName,
      );
      const warehouseId = resolve(
        r["warehouseId (optional)"] || r.warehouseId,
        r.warehouseName,
        warehouseByName,
      );
      const unitId = resolve(
        r["unitId (optional)"] || r.unitId,
        r.unitName,
        unitByName,
      );
      const categoryId = resolve(
        r["categoryId (optional)"] || r.categoryId,
        r.categoryName,
        categoryByName,
      );
      const subcategoryId = resolve(
        r["subcategoryId (optional)"] || r.subcategoryId,
        r.subcategoryName,
        subcatByName,
      );
      const brandId = resolve(
        r["brandId (optional)"] || r.brandId,
        r.brandName,
        brandByName,
      );
      const warrantyId = resolve(
        r["warrantyId (optional)"] || r.warrantyId,
        r.warrantyName,
        warrantyByName,
      );
      const variantAttrId = resolve(
        r["variantAttributeId (optional)"] || r.variantAttributeId,
        r.variantAttributeName,
        vaByName,
      );

      // required (row-level) fields
      must(storeId, "store");
      must(warehouseId, "warehouse");
      must(unitId, "unit");
      must(r.productType, "productType");
      must(r.sku, "sku");

      // build product FIRST
      const product = {
        store: storeId,
        warehouse: warehouseId,
        unit: unitId,
        productType: (r.productType || "single").toLowerCase(),
        productName: { en: r.productName_en || "", ar: r.productName_ar || "" },
        slug: { en: r.slug_en || "", ar: r.slug_ar || "" },
        sku: r.sku || "",
        itemCode: r.itemCode || "",
        sellingType: r.sellingType || "",
        category: categoryId || "",
        subcategory: subcategoryId || "",
        brand: brandId || "",
        description: {
          en: (r.description_en || "").trim(),
          ar: (r.description_ar || "").trim(),
        },
        barcodeSymbology: r.barcodeSymbology || "",
        warranty: warrantyId || "",
        manufacturer: {
          en: r.manufacturer_en || "",
          ar: r.manufacturer_ar || "",
        },
        manufacturedDate: r.manufacturedDate
          ? new Date(r.manufacturedDate)
          : null,
        expiryDate: r.expiryDate ? new Date(r.expiryDate) : null,
        hasWarranty: !!warrantyId,
        hasExpiry: !!r.expiryDate,
        // images: r.imagesBase64 || "",
      };

      // NOW it’s safe to validate fields on product
      must(product.description.en, "description_en");
      must(product.description.ar, "description_ar");

      const pricing = {
        productType: product.productType,
        quantity: Number(r.quantity || 0),
        price: Number(r.price || 0),
        taxType: r.taxType || "",
        discountType: r.discountType || "",
        discountValue: Number(r.discountValue || 0),
        quantityAlert: Number(r.quantityAlert || 0),
      };

      // avoid shadowing state: use a different name
      let variantAttributeIds = [];
      let variants = [];

      // helper: split semicolon lists (keeps positions, trims)
      const splitArr = (key) => {
        const raw = r[key];
        if (raw == null || raw === "") return [];
        return String(raw)
          .split(";")
          .map((s) => s.trim());
      };

      if (product.productType === "variable") {
        if (!variantAttrId) {
          err.push(
            "variantAttributeName or variantAttributeId is required for variable product",
          );
        } else {
          variantAttributeIds = [variantAttrId];

          const values = (r.variantValues_en || "")
            .split(";")
            .map((s) => s.trim())
            .filter(Boolean);

          const len = values.length;

          // read arrays
          let vPrices = splitArr("variant_prices");
          let vQtys = splitArr("variant_quantities");
          let vTaxTypes = splitArr("variant_taxTypes");
          let vDiscTypes = splitArr("variant_discountTypes");
          let vDiscValues = splitArr("variant_discountValues");
          let vQtyAlerts = splitArr("variant_quantityAlerts");
          let vItemCodes = splitArr("variant_itemCodes");
          let vBarcodeSyms = splitArr("variant_barcodeSymbologies");
          // let vImages = splitArr("variant_imagesBase64");

          // normalize helper: truncate extras to match variant count
          const fit = (arr) => (arr.length > len ? arr.slice(0, len) : arr);

          vPrices = fit(vPrices);
          vQtys = fit(vQtys);
          vTaxTypes = fit(vTaxTypes);
          vDiscTypes = fit(vDiscTypes);
          vDiscValues = fit(vDiscValues);
          vQtyAlerts = fit(vQtyAlerts);
          vItemCodes = fit(vItemCodes);
          vBarcodeSyms = fit(vBarcodeSyms);
          // vImages = fit(vImages);

          // row-level defaults
          const rowDefaults = {
            price: Number(r.price || 0),
            quantity: Number(r.quantity || 0),
            taxType: r.taxType || "",
            discountType: r.discountType || "",
            discountValue: Number(r.discountValue || 0),
            quantityAlert: Number(r.quantityAlert || 0),
            itemCode: r.itemCode || "",
            barcodeSymbology: r.barcodeSymbology || "",
            // image: r.imagesBase64 || "",
          };

          variants = values.map((val, i) => ({
            attribute: {
              en: r.variantAttributeName || "Attribute",
              ar: r.variantAttributeName || "Attribute",
            },
            value: { en: val, ar: val },

            // use per-variant if present, else row default
            price:
              vPrices[i] !== undefined && vPrices[i] !== ""
                ? Number(vPrices[i])
                : rowDefaults.price,
            quantity:
              vQtys[i] !== undefined && vQtys[i] !== ""
                ? Number(vQtys[i])
                : rowDefaults.quantity,
            taxType:
              vTaxTypes[i] !== undefined && vTaxTypes[i] !== ""
                ? vTaxTypes[i]
                : rowDefaults.taxType,
            discountType:
              vDiscTypes[i] !== undefined && vDiscTypes[i] !== ""
                ? vDiscTypes[i]
                : rowDefaults.discountType,
            discountValue:
              vDiscValues[i] !== undefined && vDiscValues[i] !== ""
                ? Number(vDiscValues[i])
                : rowDefaults.discountValue,
            quantityAlert:
              vQtyAlerts[i] !== undefined && vQtyAlerts[i] !== ""
                ? Number(vQtyAlerts[i])
                : rowDefaults.quantityAlert,
            itemCode:
              vItemCodes[i] !== undefined && vItemCodes[i] !== ""
                ? vItemCodes[i]
                : rowDefaults.itemCode,
            barcodeSymbology:
              vBarcodeSyms[i] !== undefined && vBarcodeSyms[i] !== ""
                ? vBarcodeSyms[i]
                : rowDefaults.barcodeSymbology,
            // image:
            //   vImages[i] !== undefined && vImages[i] !== ""
            //     ? vImages[i]
            //     : rowDefaults.image,

            sku: `SKU-${Math.floor(100000 + Math.random() * 900000)}`,
            tax: "",
          }));
        }
      }

      if (err.length) {
        errs.push({ index: idx + 2, errors: err }); // +2 = header + 1-based
      }

      return {
        product,
        pricing,
        variants,
        variantAttributes: variantAttributeIds,
      };
    });

    setBulkItems(items);
    setBulkErrors(errs);
  };

  // handle file input
  const handleBulkFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const ext = file.name.split(".").pop().toLowerCase();
    if (!["xlsx", "xls", "csv"].includes(ext)) {
      toast.error(
        `${ext} ${window.translate(
          "is not supported. Please select an Excel or CSV file.",
        )}`,
      );
      return;
    }
    setBulkFile(file);
    await parseFile(file);
  };

  // submit to backend
  const handleBulkSubmit = async () => {
    if (!bulkItems.length) {
      toast.error(
        `${window.translate("No items to upload. Please select a valid file.")}`,
      );
      return;
    }
    if (bulkErrors.length) {
      toast.error(
        `${window.translate(
          "Please fix errors before uploading. Check console for details.",
        )}`,
      );
      return;
    }
    setUploading(true);
    const { success, data, error } = await bulkUploadProducts(bulkItems);
    setUploading(false);

    if (success) {
      // show row-wise failures (if any)
      if (data.results?.some((r) => !r.ok)) {
        console.table(
          data.results
            .filter((r) => !r.ok)
            .map((r) => ({ row: r.index + 2, error: r.error })),
        );
        toast.warn(`${data.failed} rows failed. Check console for details.`);
      }
      // Optional: navigate or reset
      navigate("/product-list");
    } else {
      console.error(error);
    }
  };

  const sellingtype = [
    { value: "choose", label: "Choose" },
    { value: "transactionalSelling", label: "Transactional selling" },
    { value: "solutionSelling", label: "Solution selling" },
  ];
  const barcodesymbol = [
    { value: "choose", label: "Choose" },
    { value: "code34", label: "Code34" },
    { value: "code35", label: "Code35" },
    { value: "code36", label: "Code36" },
  ];
  const discounttype = [
    { value: "choose", label: "Choose" },
    { value: "percentage", label: "Percentage" },
    { value: "cash", label: "Cash" },
  ];

  const close = () => {
    navigate("/product-list");
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>{window.translate("Create Product")}</h4>
                <h6>{window.translate("Create new product")}</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <RefreshIcon />
              <CollapesIcon />
              <li>
                <div className="page-btn">
                  <Link to={route.productlist} className="btn btn-secondary">
                    <ArrowLeft className="me-2" />
                    Back to Product
                  </Link>
                </div>
              </li>
            </ul>
          </div>

          {/* Mode Switch */}
          <div className="mode-switch d-flex align-items-center justify-content-between mb-3">
            <div className="btn-group" role="group" aria-label="Mode switch">
              {/* Single */}
              <input
                type="radio"
                className="btn-check"
                name="mode"
                id="modeSingle"
                checked={mode === "single"}
                onChange={() => setMode("single")}
              />
              <label
                htmlFor="modeSingle"
                className={`mode-chip btn rounded-pill px-3 py-2 shadow-sm me-2 ${
                  mode === "single" ? "mode-chip--active" : "btn-outline-light"
                }`}
              >
                <span
                  className="mode-dot me-2"
                  style={{ paddingRight: "3px" }}
                />
                <span className="fw-semibold">
                  {window.translate("Single")}
                </span>
                <small
                  className="text-muted ms-2 d-none d-sm-inline"
                  style={{ paddingLeft: "8px" }}
                >
                  {window.translate("Add one item")}
                </small>
              </label>

              {/* Bulk */}
              <input
                type="radio"
                className="btn-check"
                name="mode"
                id="modeBulk"
                checked={mode === "bulk"}
                onChange={() => setMode("bulk")}
              />
              <label
                htmlFor="modeBulk"
                className={`mode-chip btn rounded-pill px-3 py-2 shadow-sm ${
                  mode === "bulk" ? "mode-chip--active" : "btn-outline-light"
                }`}
              >
                <span
                  className="mode-dot me-2"
                  style={{ paddingRight: "3px" }}
                />
                <span className="fw-semibold">
                  {window.translate("Bulk Upload")}
                </span>
                <small
                  className="text-muted ms-3 d-none d-sm-inline"
                  style={{ paddingLeft: "8px" }}
                >
                  {window.translate("Import via file")}
                </small>
              </label>
            </div>

            {/* Optional helper text on larger screens */}
            <div className="text-muted small d-none d-md-block">
              {window.translate("Tip: download the template before uploading.")}
            </div>
          </div>

          {/* Bulk Upload Products */}

          {mode === "bulk" && (
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="mb-0">
                  {window.translate("Bulk Upload Products")}
                </h5>
                <div className="d-flex gap-2">
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    onClick={handleDownloadTemplate}
                  >
                    {window.translate("Download Template")}
                  </button>
                  <label className="btn btn-primary btn-sm mb-0">
                    {window.translate("Choose File")}
                    <input
                      type="file"
                      accept=".xlsx,.xls,.csv"
                      hidden
                      onChange={handleBulkFile}
                    />
                  </label>
                  <button
                    type="button"
                    className="btn btn-success btn-sm"
                    disabled={!bulkFile || uploading}
                    onClick={handleBulkSubmit}
                  >
                    {uploading
                      ? `${window.translate("Uploading...")}`
                      : `${window.translate("Upload")}`}
                  </button>
                </div>
              </div>

              <div className="card-body">
                {bulkFile ? (
                  <div className="text-muted small">
                    {window.translate("Selected")}: {bulkFile.name}
                  </div>
                ) : (
                  <div className="text-muted">
                    {window.translate("No file selected.")}
                  </div>
                )}

                {/* Optional errors/preview if you implement parsing */}
                {bulkErrors.length > 0 && (
                  <div className="alert alert-warning mt-3">
                    <strong>
                      {window.translate("Fix these before upload")}:
                    </strong>
                    <ul className="mb-0">
                      {bulkErrors.slice(0, 8).map((e, i) => (
                        <li key={i}>
                          {window.translate("Row")} {e.index}:{" "}
                          {e.errors.join(", ")}
                        </li>
                      ))}
                    </ul>
                    {bulkErrors.length > 8 && (
                      <small>…and {bulkErrors.length - 8} more</small>
                    )}
                  </div>
                )}
                {bulkRows.length > 0 && (
                  <div className="table-responsive mt-3">
                    <table className="table table-sm">
                      <thead>
                        <tr>
                          {Object.keys(bulkRows[0]).map((h) => (
                            <th key={h}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {bulkRows.slice(0, 20).map((row, i) => (
                          <tr key={i}>
                            {Object.keys(bulkRows[0]).map((h) => (
                              <td key={h}>{String(row[h] ?? "")}</td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {bulkRows.length > 20 && (
                      <div className="text-muted small">
                        {window.translate("Showing first 20 of")}{" "}
                        {bulkRows.length} rows…
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* /add */}
          {mode === "single" && (
            <form className="add-product-form" onSubmit={handleSubmit}>
              <div className="add-product">
                <div
                  className="accordions-items-seperate"
                  id="accordionSpacingExample"
                >
                  <div className="accordion-item border mb-4">
                    <h2 className="accordion-header" id="headingSpacingOne">
                      <div
                        className="accordion-button collapsed bg-white"
                        data-bs-toggle="collapse"
                        data-bs-target="#SpacingOne"
                        aria-expanded="true"
                        aria-controls="SpacingOne"
                      >
                        <div className="d-flex align-items-center justify-content-between flex-fill">
                          <h5 className="d-flex align-items-center gap-2">
                            <Info className="text-primary me-2" />
                            <span>
                              {window.translate("Product Information")}
                            </span>
                          </h5>
                        </div>
                      </div>
                    </h2>
                    <div
                      id="SpacingOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingSpacingOne"
                    >
                      <div className="accordion-body border-top">
                        <div className="row">
                          <div className="col-sm-6 col-12">
                            <div className="mb-3">
                              <label className="form-label">
                                {window.translate("Store")}
                                <span className="text-danger ms-1">*</span>
                              </label>
                              {/* <Select
                              classNamePrefix="react-select"
                              options={store}
                              placeholder="Choose"
                            /> */}
                              <Select
                                classNamePrefix="react-select"
                                options={storeList}
                                placeholder="Choose"
                                value={storeValue}
                                onChange={setStoreValue}
                              />
                            </div>
                          </div>
                          <div className="col-sm-6 col-12">
                            <div className="mb-3">
                              <label className="form-label">
                                {window.translate("Warehouse")}
                                <span className="text-danger ms-1">*</span>
                              </label>
                              {/* <Select
                              classNamePrefix="react-select"
                              options={warehouse}
                              placeholder="Choose"
                            /> */}
                              <Select
                                classNamePrefix="react-select"
                                options={warehouseList}
                                placeholder="Choose"
                                value={warehouseValue}
                                onChange={setWarehouseValue}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6 col-12">
                            <div className="mb-3">
                              <label className="form-label">
                                {window.translate("Product Name (EN)")}
                                <span className="text-danger ms-1">*</span>
                              </label>
                              {/* <input type="text" className="form-control" /> */}
                              <input
                                type="text"
                                className="form-control"
                                value={productNameEN}
                                onChange={(e) =>
                                  setProductNameEN(e.target.value)
                                }
                              />
                            </div>
                          </div>
                          <div className="col-sm-6 col-12">
                            <div className="mb-3">
                              <label className="form-label">
                                {window.translate("Product Name (AR)")}
                                <span className="text-danger ms-1">*</span>
                              </label>
                              {/* <input type="text" className="form-control" /> */}
                              <input
                                type="text"
                                className="form-control"
                                value={productNameAR}
                                onChange={(e) =>
                                  setProductNameAR(e.target.value)
                                }
                              />
                            </div>
                          </div>
                          <div className="col-sm-6 col-12">
                            <div className="mb-3">
                              <label className="form-label">
                                {window.translate("Slug (EN)")}
                                <span className="text-danger ms-1">*</span>
                              </label>
                              {/* <input type="text" className="form-control" /> */}
                              <input
                                type="text"
                                className="form-control"
                                value={slugEN}
                                onChange={(e) => setSlugEN(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-sm-6 col-12">
                            <div className="mb-3">
                              <label className="form-label">
                                {window.translate("Slug (AR)")}
                                <span className="text-danger ms-1">*</span>
                              </label>
                              {/* <input type="text" className="form-control" /> */}
                              <input
                                type="text"
                                className="form-control"
                                value={slugAR}
                                onChange={(e) => setSlugAR(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6 col-12">
                            <div className="mb-3 list position-relative">
                              <label className="form-label">
                                {window.translate("SKU")}
                                <span className="text-danger ms-1">*</span>
                              </label>
                              {/* <input type="text" className="form-control list" /> */}
                              <input
                                type="text"
                                style={{ paddingRight: "50px" }}
                                className="form-control list"
                                value={sku}
                                onChange={(e) => setSku(e.target.value)}
                              />
                              <button
                                type="button"
                                className="btn btn-primaryadd"
                                onClick={() => setSku(generateRandomSku())}
                              >
                                {window.translate("Generate")}
                              </button>
                            </div>
                          </div>
                          <div className="col-sm-6 col-12">
                            <div className="mb-3">
                              <label className="form-label">
                                {window.translate("Selling Type")}
                                <span className="text-danger ms-1">*</span>
                              </label>
                              {/* <Select
                              classNamePrefix="react-select"
                              options={sellingtype}
                              placeholder="Choose"
                            /> */}
                              <Select
                                classNamePrefix="react-select"
                                options={sellingtype}
                                placeholder="Choose"
                                value={sellingTypeValue}
                                onChange={setSellingTypeValue}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="addservice-info">
                          <div className="row">
                            <div className="col-sm-6 col-12">
                              <div className="mb-3">
                                <div className="add-newplus">
                                  <label className="form-label">
                                    {window.translate("Category")}
                                    <span className="text-danger ms-1">*</span>
                                  </label>
                                  {/* <Link
                                  to="#"
                                  data-bs-toggle="modal"
                                  data-bs-target="#add-units-category"
                                >
                                  <PlusCircle
                                    data-feather="plus-circle"
                                    className="plus-down-add"
                                  />
                                  <span>Add New</span>
                                </Link> */}
                                </div>
                                {/* <Select
                                classNamePrefix="react-select"
                                options={category}
                                placeholder="Choose"
                              /> */}
                                <Select
                                  classNamePrefix="react-select"
                                  options={category}
                                  placeholder="Choose"
                                  value={categoryValue}
                                  onChange={(selectedOption) => {
                                    console.log(
                                      "Selected Category Object:",
                                      selectedOption,
                                    );
                                    console.log(
                                      "Selected Category ID:",
                                      selectedOption?.value,
                                    );
                                    setCategoryValue(selectedOption);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-sm-6 col-12">
                              <div className="mb-3">
                                <label className="form-label">
                                  {window.translate("Sub Category")}
                                  <span className="text-danger ms-1">*</span>
                                </label>
                                {/* <Select
                                classNamePrefix="react-select"
                                options={subcategory}
                                placeholder="Choose"
                              /> */}
                                <Select
                                  classNamePrefix="react-select"
                                  options={subCategoryOptions}
                                  placeholder="Choose"
                                  value={subCategoryValue}
                                  onChange={setSubCategoryValue}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="add-product-new">
                          <div className="row">
                            <div className="col-sm-6 col-12">
                              <div className="mb-3">
                                <div className="add-newplus">
                                  <label className="form-label">
                                    {window.translate("Brand")}
                                    <span className="text-danger ms-1">*</span>
                                  </label>
                                </div>
                                {/* <Select
                                classNamePrefix="react-select"
                                options={brand}
                                placeholder="Choose"
                              /> */}
                                <Select
                                  classNamePrefix="react-select"
                                  options={brandList}
                                  placeholder="Choose"
                                  value={brandValue}
                                  onChange={setBrandValue}
                                />
                              </div>
                            </div>
                            <div className="col-sm-6 col-12">
                              <div className="mb-3">
                                <div className="add-newplus">
                                  <label className="form-label">
                                    {window.translate("Unit")}
                                    <span className="text-danger ms-1">*</span>
                                  </label>
                                </div>
                                {unitList.length === 0 ? (
                                  <div>
                                    {window.translate("Loading units...")}
                                  </div>
                                ) : (
                                  <Select
                                    options={unitList}
                                    value={unitValue}
                                    onChange={setUnitValue}
                                    placeholder="Choose Unit"
                                    isClearable
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-sm-6 col-12">
                            <div className="mb-3">
                              <label className="form-label">
                                {window.translate("Barcode Symbology")}
                                <span className="text-danger ms-1">*</span>
                              </label>
                              {/* <Select
                              classNamePrefix="react-select"
                              options={barcodesymbol}
                              placeholder="Choose"
                            /> */}
                              <Select
                                classNamePrefix="react-select"
                                options={barcodesymbol}
                                placeholder="Choose"
                                value={barcodeSymbologyValue}
                                onChange={setBarcodeSymbologyValue}
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-sm-6 col-12">
                            <div className="mb-3 list position-relative">
                              <label className="form-label">
                                {window.translate("Item Code")}
                                <span className="text-danger ms-1">*</span>
                              </label>
                              {/* <input type="text" className="form-control list" /> */}
                              <input
                                type="text"
                                style={{ paddingRight: "50px" }}
                                className="form-control list"
                                value={itemCode}
                                onChange={(e) => setItemCode(e.target.value)}
                              />
                              <button
                                type="button"
                                className="btn btn-primaryadd"
                                onClick={() =>
                                  setItemCode(generateRandomItemCode())
                                }
                              >
                                {window.translate("Generate")}
                              </button>
                            </div>
                          </div>
                        </div>
                        {/* Editor */}
                        <div className="col-lg-12">
                          <div className="summer-description-box">
                            <label className="form-label">
                              {window.translate("description")}
                            </label>
                            <TextEditor
                              value={descriptionEN}
                              onChange={(value) => setDescriptionEN(value)}
                            />
                            <p className="fs-14 mt-1">
                              {window.translate("Maximum 60 Words")}
                            </p>
                          </div>
                        </div>

                        <div className="col-lg-12">
                          <div className="summer-description-box">
                            <label className="form-label">
                              {window.translate("description")}
                            </label>
                            <TextEditor
                              value={descriptionAR}
                              onChange={(value) => setDescriptionAR(value)}
                            />
                            <p className="fs-14 mt-1">
                              {window.translate("Maximum 60 Words")}
                            </p>
                          </div>
                        </div>
                        {/* /Editor */}
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item border mb-4">
                    <h2 className="accordion-header" id="headingSpacingTwo">
                      <div
                        className="accordion-button collapsed bg-white"
                        data-bs-toggle="collapse"
                        data-bs-target="#SpacingTwo"
                        aria-expanded="true"
                        aria-controls="SpacingTwo"
                      >
                        <div className="d-flex align-items-center justify-content-between flex-fill">
                          <h5 className="d-flex align-items-center gap-2">
                            <LifeBuoy
                              data-feather="life-buoy"
                              className="text-primary me-2"
                            />
                            <span>
                              {window.translate("Pricing")} &amp;{" "}
                              {window.translate("Stocks")}
                            </span>
                          </h5>
                        </div>
                      </div>
                    </h2>
                    <div
                      id="SpacingTwo"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingSpacingTwo"
                    >
                      <div className="accordion-body border-top">
                        <div className="mb-3s">
                          <label className="form-label">
                            {window.translate("Product Type")}
                            <span className="text-danger ms-1">*</span>
                          </label>
                          <div className="single-pill-product mb-3">
                            <ul
                              className="nav nav-pills"
                              id="pills-tab1"
                              role="tablist"
                            >
                              <li className="nav-item" role="presentation">
                                <span
                                  className={`custom_radio me-4 mb-0 ${
                                    productType === "single" ? "active" : ""
                                  }`}
                                  onClick={() => setProductType("single")}
                                >
                                  <input
                                    type="radio"
                                    className="form-control"
                                    name="productType"
                                    value="single"
                                    checked={productType === "single"}
                                    onChange={(e) =>
                                      setProductType(e.target.value)
                                    }
                                  />
                                  <span className="checkmark" />{" "}
                                  {window.translate("Single Product")}
                                </span>
                              </li>
                              {showVariableProduct && (
                                <li className="nav-item" role="presentation">
                                  <span
                                    className={`custom_radio me-2 mb-0 ${
                                      productType === "variable" ? "active" : ""
                                    }`}
                                    onClick={() => setProductType("variable")}
                                  >
                                    <input
                                      type="radio"
                                      className="form-control"
                                      name="productType"
                                      value="variable"
                                      checked={productType === "variable"}
                                      onChange={(e) =>
                                        setProductType(e.target.value)
                                      }
                                    />
                                    <span className="checkmark" />{" "}
                                    {window.translate("Variable Product")}
                                  </span>
                                </li>
                              )}
                            </ul>
                          </div>
                        </div>
                        <div className="tab-content" id="pills-tabContent">
                          <div
                            className={`tab-pane fade ${
                              productType === "single" ? "show active" : ""
                            }`}
                            id="pills-home"
                            role="tabpanel"
                          >
                            <div className="single-product">
                              <div className="row">
                                <div className="col-lg-4 col-sm-6 col-12">
                                  <div className="mb-3">
                                    <label className="form-label">
                                      {window.translate("Quantity")}
                                      <span className="text-danger ms-1">
                                        *
                                      </span>
                                    </label>
                                    {/* <input type="text" className="form-control" /> */}
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={quantity}
                                      onChange={(e) =>
                                        setQuantity(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-4 col-sm-6 col-12">
                                  <div className="mb-3">
                                    <label className="form-label">
                                      {window.translate("Price")}
                                      <span className="text-danger ms-1">
                                        *
                                      </span>
                                    </label>
                                    {/* <input type="text" className="form-control" /> */}
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={price}
                                      onChange={(e) => setPrice(e.target.value)}
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-4 col-sm-6 col-12">
                                  <div className="mb-3">
                                    <label className="form-label">
                                      {window.translate("Tax Type")}
                                      <span className="text-danger ms-1">
                                        *
                                      </span>
                                    </label>
                                    {/* <Select
                                    classNamePrefix="react-select"
                                    options={taxTypeOptions}
                                    placeholder="Select Option"
                                  /> */}
                                    <Select
                                      classNamePrefix="react-select"
                                      options={taxTypeOptions}
                                      placeholder="Select Option"
                                      value={taxType}
                                      onChange={setTaxType}
                                      isLoading={loadingTaxTypes}
                                      noOptionsMessage={() =>
                                        loadingTaxTypes
                                          ? window.translate("Loading...")
                                          : window.translate("No tax types found")
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-4 col-sm-6 col-12">
                                  <div className="mb-3">
                                    <label className="form-label">
                                      {window.translate("Discount Type")}
                                      <span className="text-danger ms-1">
                                        *
                                      </span>
                                    </label>
                                    {/* <Select
                                    classNamePrefix="react-select"
                                    options={discounttype}
                                    placeholder="Choose"
                                  /> */}
                                    <Select
                                      classNamePrefix="react-select"
                                      options={discounttype}
                                      placeholder="Choose"
                                      value={discountType}
                                      onChange={setDiscountType}
                                      styles={{
                                        menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 9999,
                                        }),
                                      }}
                                      menuPortalTarget={document.body}
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-4 col-sm-6 col-12">
                                  <div className="mb-3">
                                    <label className="form-label">
                                      {window.translate("Discount Value")}
                                      <span className="text-danger ms-1">
                                        *
                                      </span>
                                    </label>
                                    {/* <input className="form-control" type="text" /> */}
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={discountValue}
                                      onChange={(e) =>
                                        setDiscountValue(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-4 col-sm-6 col-12">
                                  <div className="mb-3">
                                    <label className="form-label">
                                      {window.translate("Quantity Alert Level")}
                                      <span className="text-danger ms-1">
                                        *
                                      </span>
                                    </label>
                                    {/* <input type="text" className="form-control" /> */}
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={quantityAlert}
                                      onChange={(e) =>
                                        setQuantityAlert(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className={`tab-pane fade ${
                              productType === "variable" ? "show active" : ""
                            }`}
                            id="pills-profile"
                            role="tabpanel"
                          >
                            <div className="row select-color-add">
                              <div className="col-lg-6 col-sm-6 col-12">
                                <div className="mb-3">
                                  <label className="form-label">
                                    {window.translate("Variant Attribute")}{" "}
                                    <span className="text-danger ms-1">*</span>
                                  </label>
                                  <div className="row">
                                    <div className="col-lg-10 col-sm-10 col-10">
                                      <select
                                        className="form-control variant-select select-option"
                                        onChange={(e) => {
                                          const selected =
                                            variantAttributes.find(
                                              (attr) =>
                                                attr.name?._id &&
                                                attr.name._id.toString() ===
                                                  e.target.value,
                                            );
                                          console.log(
                                            "Selected variant ID:",
                                            e.target.value,
                                          );
                                          console.log(
                                            "Matched variant:",
                                            selected,
                                          );
                                          setSelectedVariant(selected);
                                          setProduct(true);
                                        }}
                                      >
                                        <option value="">Choose</option>
                                        {variantAttributes.map((attribute) => (
                                          <option
                                            key={attribute.name?._id}
                                            value={attribute.name?._id}
                                          >
                                            {attribute.name?.en}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                    <div className="col-lg-2 col-sm-2 col-2 ps-0">
                                      <div className="add-icon tab">
                                        <Link
                                          className="btn btn-filter"
                                          data-bs-toggle="modal"
                                          data-bs-target="#add-units"
                                        >
                                          <i className="feather feather-plus-circle" />
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {product && (
                                  <div
                                    className={`selected-hide-color ${
                                      product2 ? "d-block" : ""
                                    } `}
                                    id="input-show"
                                  >
                                    <label className="form-label">
                                      {window.translate("Variant Attribute")}{" "}
                                      <span className="text-danger ms-1">
                                        *
                                      </span>
                                    </label>
                                    <div className="row align-items-center">
                                      <div className="col-lg-10 col-sm-10 col-10">
                                        <div className="mb-3">
                                          <CommonTagsInput
                                            value={tags}
                                            suggestions={variantValues.map(
                                              (v) => v.en,
                                            )}
                                            onChange={(newTags) => {
                                              // Filter variantList to only those still in tags
                                              const updatedVariantList =
                                                variantList.filter((v) =>
                                                  newTags.includes(v.value.en),
                                                );
                                              setTags(newTags);
                                              setVariantList(
                                                updatedVariantList,
                                              );
                                            }}
                                            placeholder="Add new"
                                            className="input-tags form-control" // Optional custom class
                                          />
                                        </div>
                                      </div>
                                      <div className="col-lg-2 col-sm-2 col-2 ps-0">
                                        <div className="mb-3 ">
                                          <Link
                                            to="#"
                                            className="remove-color"
                                            onClick={() => setProduct2(false)}
                                          >
                                            <i className="far fa-trash-alt" />
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                            {product && (
                              <div
                                className="modal-body-table variant-table d-block"
                                id="variant-table"
                              >
                                <div className="table-responsive">
                                  <table className="table">
                                    <thead>
                                      <tr>
                                        <th>
                                          {window.translate("Variantion")}
                                        </th>
                                        <th>
                                          {window.translate("Variant Value")}
                                        </th>
                                        <th>{window.translate("SKU")}</th>
                                        <th>{window.translate("Quantity")}</th>
                                        <th>{window.translate("Price")}</th>
                                        <th className="no-sort" />
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {variantList.map((variant, index) => (
                                        <tr key={index}>
                                          <td>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={
                                                variant.attribute?.en ||
                                                "Variant"
                                              }
                                              readOnly
                                            />
                                          </td>

                                          <td>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={variant.value?.en || ""}
                                              readOnly
                                            />
                                          </td>

                                          <td>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={variant.sku || ""}
                                              readOnly
                                            />
                                          </td>

                                          {/* ✅ QUANTITY COLUMN */}
                                          <td>
                                            <input
                                              type="number"
                                              className="form-control"
                                              value={variant.quantity || ""}
                                              onChange={(e) => {
                                                const updated = [
                                                  ...variantList,
                                                ];
                                                updated[index].quantity =
                                                  e.target.value;
                                                setVariantList(updated);
                                              }}
                                            />
                                          </td>

                                          {/* ✅ PRICE COLUMN */}
                                          <td>
                                            <input
                                              type="number"
                                              className="form-control"
                                              value={variant.price || ""}
                                              onChange={(e) => {
                                                const updated = [
                                                  ...variantList,
                                                ];
                                                updated[index].price =
                                                  e.target.value;
                                                setVariantList(updated);
                                              }}
                                            />
                                          </td>

                                          <td className="action-table-data">
                                            <div className="edit-delete-action">
                                              <Link
                                                to="#"
                                                className="me-2 p-2"
                                                data-bs-toggle="modal"
                                                data-bs-target="#add-variation"
                                                onClick={() => {
                                                  setEditingIndex(index);
                                                  setModalData(variant);
                                                }}
                                              >
                                                <Plus className="feather-edit" />
                                              </Link>

                                              <Link
                                                to="#"
                                                className="p-2"
                                                onClick={() => {
                                                  const removedValue =
                                                    variantList[index].value.en;

                                                  const updatedList = [
                                                    ...variantList,
                                                  ];
                                                  updatedList.splice(index, 1);
                                                  setVariantList(updatedList);

                                                  const updatedTags =
                                                    tags.filter(
                                                      (tag) =>
                                                        tag !== removedValue,
                                                    );
                                                  setTags(updatedTags);
                                                }}
                                              >
                                                <i className="feather-trash-2" />
                                              </Link>
                                            </div>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item border mb-4">
                    <h2 className="accordion-header" id="headingSpacingThree">
                      <div
                        className="accordion-button collapsed bg-white"
                        data-bs-toggle="collapse"
                        data-bs-target="#SpacingThree"
                        aria-expanded="true"
                        aria-controls="SpacingThree"
                      >
                        <div className="d-flex align-items-center justify-content-between flex-fill">
                          <h5 className="d-flex align-items-center">
                            {/* <Image
                            data-feather="image"
                            
                          /> */}

                            <span>{window.translate("Images")}</span>
                          </h5>
                        </div>
                      </div>
                    </h2>
                    <div
                      id="SpacingThree"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingSpacingThree"
                    >
                      {/* <div className="accordion-body border-top">
                      <div className="text-editor add-list add">
                        <div className="col-lg-12">
                          <div className="add-choosen">
                            <div className="mb-3">
                              <div className="image-upload">
                                <input
                                  className="text-primary me-2"
                                  type="file"
                                  onChange={handleImageChange}
                                />
                                <div className="image-uploads">
                                  <PlusCircle
                                    data-feather="plus-circle"
                                    className="plus-down-add me-0"
                                  />
                                  <h4>Add Images</h4>
                                </div>
                              </div>
                            </div>
                             {isImageVisible1 && (
                              <div className="phone-img">
                                <ImageWithBasePath
                                  src="assets/img/products/phone-add-2.png"
                                  alt="image"
                                />
                                <Link to="#">
                                  <X
                                    className="x-square-add remove-product"
                                    onClick={handleRemoveProduct1}
                                  />
                                </Link>
                              </div>
                            )}
                            {isImageVisible && (
                              <div className="phone-img">
                                <ImageWithBasePath
                                  src="assets/img/products/phone-add-1.png"
                                  alt="image"
                                />
                                <Link to="#">
                                  <X
                                    className="x-square-add remove-product"
                                    onClick={handleRemoveProduct}
                                  />
                                </Link>
                              </div>
                            )} 
                          </div>
                        </div>
                      </div>
                    </div> */}
                      <div className="accordion-body border-top">
                        <div className="text-editor add-list add">
                          <div className="col-lg-12">
                            <div className="add-choosen">
                              <div className="mb-3">
                                <div className="image-uploads">
                                  <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleImageChange}
                                    id="imageUploadInput"
                                    style={{ display: "none" }}
                                  />

                                  <label
                                    htmlFor="imageUploadInput"
                                    className="image-uploads d-flex justify-content-center align-items-center"
                                    style={{
                                      width: "150px",
                                      height: "150px",
                                      backgroundColor: "#f3f8f9",
                                      border: "1px dashed #ccc",
                                      borderRadius: "10px",
                                      position: "relative",
                                      overflow: "hidden",
                                    }}
                                  >
                                    {imagePreview ? (
                                      <>
                                        <img
                                          src={imagePreview}
                                          alt="Preview"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            borderRadius: "10px",
                                          }}
                                        />
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-danger position-absolute"
                                          style={{
                                            top: "6px",
                                            right: "6px",
                                            width: "24px",
                                            height: "24px",
                                            padding: 0,
                                            borderRadius: "50%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            fontSize: "16px",
                                          }}
                                          onClick={handleRemoveImage}
                                          title="Remove image"
                                        >
                                          ×
                                        </button>
                                      </>
                                    ) : (
                                      <div className="text-center">
                                        <PlusCircle className="mb-1" />
                                        <h6 className="m-0">
                                          {window.translate("Add Images")}
                                        </h6>
                                      </div>
                                    )}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item border mb-4">
                    <h2 className="accordion-header" id="headingSpacingFour">
                      <div
                        className="accordion-button collapsed bg-white"
                        data-bs-toggle="collapse"
                        data-bs-target="#SpacingFour"
                        aria-expanded="true"
                        aria-controls="SpacingFour"
                      >
                        <div className="d-flex align-items-center justify-content-between flex-fill">
                          <h5 className="d-flex align-items-center gap-2">
                            <List
                              data-feather="list"
                              className="text-primary me-2"
                            />
                            <span>{window.translate("Custom Fields")}</span>
                          </h5>
                        </div>
                      </div>
                    </h2>
                    <div
                      id="SpacingFour"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingSpacingFour"
                    >
                      <div className="accordion-body border-top">
                        <div>
                          <div className="p-3 bg-light rounded d-flex align-items-center border mb-3">
                            <div className=" d-flex align-items-center">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="warranties"
                                  defaultValue="option1"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="warranties"
                                >
                                  {window.translate("Warranties")}
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="manufacturer"
                                  defaultValue="option2"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="manufacturer"
                                >
                                  {window.translate("Manufacturer")}
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="expiry"
                                  defaultValue="option2"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="expiry"
                                >
                                  {window.translate("Expiry Date")}
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-4 col-sm-6 col-12">
                              <div className="mb-3">
                                <label className="form-label">
                                  {window.translate("Warranty")}
                                  <span className="text-danger ms-1">*</span>
                                </label>
                                <Select
                                  classNamePrefix="react-select"
                                  options={warrantyList}
                                  placeholder="Choose"
                                  value={warrantyValue}
                                  onChange={setWarrantyValue}
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-sm-6 col-12">
                              <div className="mb-3 add-product">
                                <label className="form-label">
                                  {window.translate("Manufacturer")} (EN)
                                  <span className="text-danger ms-1">*</span>
                                </label>
                                {/* <input type="text" className="form-control" /> */}
                                <input
                                  type="text"
                                  className="form-control"
                                  value={manufacturerEN}
                                  onChange={(e) =>
                                    setManufacturerEN(e.target.value)
                                  }
                                />
                              </div>
                            </div>

                            <div className="col-lg-4 col-sm-6 col-12">
                              <div className="mb-3 add-product">
                                <label className="form-label">
                                  {window.translate("Manufacturer")} (AR)
                                  <span className="text-danger ms-1">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={manufacturerAR}
                                  onChange={(e) =>
                                    setManufacturerAR(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-6 col-12">
                              <div className="mb-3">
                                <label className="form-label">
                                  {window.translate("Manufactured Date")}
                                  <span className="text-danger ms-1">*</span>
                                </label>
                                <div className="input-groupicon calender-input ">
                                  <Calendar className="info-img" />
                                  <DatePicker
                                    className="form-control datetimepicker"
                                    style={{ paddingRight: "35px" }}
                                    placeholderText="dd/mm/yyyy"
                                    selected={manufacturedDate}
                                    onChange={(date) =>
                                      setManufacturedDate(date)
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-6 col-12">
                              <div className="mb-3">
                                <label className="form-label">
                                  {window.translate("Expiry On")}
                                  <span className="text-danger ms-1">*</span>
                                </label>
                                <div className="input-groupicon calender-input">
                                  <Calendar className="info-img" />
                                  <DatePicker
                                    className="form-control datetimepicker"
                                    style={{ paddingRight: "35px" }}
                                    placeholderText="dd/mm/yyyy"
                                    selected={expiryDate}
                                    onChange={(date) => setExpiryDate(date)}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="d-flex align-items-center justify-content-end mb-4 gap-2">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={close}
                    value="Cancel"
                    disabled={isSubmitting}
                  >
                    {window.translate("Cancel")}
                  </button>

                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isSubmitting}
                    aria-busy={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        />
                        {window.translate("Adding…")}
                      </>
                    ) : (
                      window.translate("Add Product")
                    )}
                  </button>
                </div>
              </div>
            </form>
          )}
          {/* /add */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0 text-gray-9">
            {window.translate("2024-2025 © Hamilton POS. All Right Reserved")}
          </p>
          <p>
            {window.translate("Designed")}{" "}
            <Link to="#" className="text-primary">
              {window.translate("Hamilton")}
            </Link>
          </p>
        </div>
      </div>
      <Addunits />
      <AddCategory />
      <AddVariant />
      <AddBrand />
      <AddVarientNew
        modalData={modalData}
        setModalData={setModalData}
        onSubmit={handleVariantSubmit}
      />
      <div className="modal fade" id="delete-modal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content p-5 px-3 text-center">
                <span className="rounded-circle d-inline-flex p-2 bg-danger-transparent mb-2">
                  <i className="ti ti-trash fs-24 text-danger"></i>
                </span>
                <h4 className="fs-20 fw-bold mb-2 mt-1">
                  {window.translate("Delete Attribute")}
                </h4>
                <p className="mb-0 fs-16">
                  {window.translate(
                    "Are you sure want to delete this attribute?",
                  )}
                </p>
                <div className="modal-footer-btn mt-3 d-flex justify-content-center">
                  <button
                    type="button"
                    className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
                    data-bs-dismiss="modal"
                  >
                    {window.translate("Cancel")}
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary fs-13 fw-medium p-2 px-3"
                  >
                    {window.translate("Yes Delete")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProduct;
